import { useMutation } from "@tanstack/react-query";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";
//----------------------------------------------------------------

const fetchAddresses = async (requestData) => {
  const { newInputValue, accessToken } = { ...requestData };

  try {
    const response = await request({
      url: "/findAddress",
      method: "POST",
      data: newInputValue,
      accessToken: accessToken,
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const useAutocompleteAddress = () => {
  return useMutation((input) => fetchAddresses(input), {
    onSuccess: (data) => {
      let newOptions = [];
      if (data) {
        newOptions = [...newOptions, ...data];
      }
      return newOptions;
    },
  });
};

//** Usage */
{
  /* <Section>
    <MyAutoComplete
    accessToken={accessToken}
    func={useAutocompleteAddress}
    label="Address"
    labelOption="fullAddress"
    />
</Section> */
}
//** Usage */
